(function () {
  if (window.__mobileBackHandlerAttached) return;
  window.__mobileBackHandlerAttached = true;

  function getFromAccountParam() {
    try {
      return new URLSearchParams(window.location.search).get('from_account');
    } catch (error) {
      return null;
    }
  }

  function getFallbackUrl(backButton) {
    var fallback = backButton.getAttribute('data-fallback-url') || backButton.getAttribute('href') || '/';
    if (getFromAccountParam() === 'info') {
      return backButton.getAttribute('data-account-info-url') || fallback;
    }
    return fallback;
  }

  document.addEventListener('click', function (event) {
    var backButton = event.target.closest('[data-mobile-back-button], [data-pdp-back-button]');
    if (!backButton) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();

    var fallbackUrl = getFallbackUrl(backButton);

    /* Canvas app WebViews often omit referrer — return to account info when tagged. */
    if (getFromAccountParam() === 'info') {
      window.location.href = fallbackUrl;
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = fallbackUrl;
  });
})();
